module.exports = __webpack_public_path__ + "img/bao_haevning.8b4c85bf.jpg";